import type { SVGProps } from 'react';

const SvgRetailPos = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M28.78 9h-3.33v1.5h3.33a1.63 1.63 0 0 1 1.63 1.63v16.62a1.63 1.63 0 0 1-1.63 1.62H3.22a1.63 1.63 0 0 1-1.63-1.62V12.13a1.63 1.63 0 0 1 1.63-1.63h3V9h-3a3.13 3.13 0 0 0-3.13 3.13v16.62a3.13 3.13 0 0 0 3.13 3.12h25.56a3.13 3.13 0 0 0 3.13-3.12V12.13A3.13 3.13 0 0 0 28.78 9" />
      <path d="M5.89 12.84v1.5h20.22v-1.5h-2.47V3a2.91 2.91 0 0 0-2.9-2.88h-9.48A2.91 2.91 0 0 0 8.36 3v9.81ZM22.14 3v9.81h-9V1.62h7.61A1.41 1.41 0 0 1 22.14 3M9.86 3a1.41 1.41 0 0 1 1.4-1.41h.37v11.25H9.86ZM26.23 23.07v-5.9a.76.76 0 0 0-.75-.75h-19a.76.76 0 0 0-.75.75v5.9a.76.76 0 0 0 .75.75h19a.76.76 0 0 0 .75-.75m-1.5-.75H7.27v-4.4h17.46ZM6.96 26.29h4.08v1.5H6.96zM13.96 26.29h4.08v1.5h-4.08zM20.96 26.29h4.08v1.5h-4.08z" />
    </g>
  </svg>
);

export default SvgRetailPos;
